export class CardOrderBase {
    KortType: string = "";
    OrdreType: string = "0";
    SendTilEkspeditionssted: boolean = false;
    GebyrFrit: boolean = false;
    UdstedelsesDato: Date | null = null;
    EkspeditionsType: number = 0;
}